import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { useStores } from 'hooks';
import { useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import style from './index.module.scss';
import Sidebar from './Sidebar';
import Header from './Header';
import useLocalStorage from 'react-use-localstorage';


export default observer(({ children }) => {
  const { uiStore: { title }, authStore: { isLoggedIn } } = useStores();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      history.push({
        pathname: '/login',
        search: `?redirect=${encodeURIComponent(location.pathname + location.search)}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const isMobile = useMediaQuery({
    query: '(max-width: 719px)',
  });

  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);
  const [isOpen, setOpen] = useLocalStorage('isSidebarOpen', true);
  const isSidebarOpen = typeof isOpen === 'string' ? isOpen === 'true' : isOpen;
  const setIsSidebarOpen = (cb) => {
    setOpen(cb(isSidebarOpen));
  }

  return (
    <div className={style.layout}>
      <Helmet>
        <title>{title ? `${title} - AMAZ Portal` : 'AMAZ Portal'}</title>
      </Helmet>
      <div className={style.left}>
        <Sidebar
          isMobile={isMobile}
          isSidebarOpen={isMobile ? isSidebarMobileOpen : isSidebarOpen}
          setIsSidebarOpen={isMobile ? setIsSidebarMobileOpen : setIsSidebarOpen}
        />
      </div>
      <div className={classnames(style.mainContainer, { [style.isSidebarOpen]: isSidebarOpen })}>
        <Header
          isSidebarOpen={isMobile ? isSidebarMobileOpen : isSidebarOpen}
          setIsSidebarOpen={isMobile ? setIsSidebarMobileOpen : setIsSidebarOpen}
        />
        <div className="mobile-only h2 p2" />
        <div className={style.content}>
          <div className="max-width-1200px m-auto pb-8">
            <div className="mt-2 mb-6">
              <h2>{title}</h2>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
});
